import toast from 'react-hot-toast'
import { IntlShape } from 'react-intl'

export const sanitizeGraphQLErrors = (
  errors: GraphqlError[],
  {
    messageCallback,
    messagePrefixKey,
    intl,
  }: {
    messageCallback?: (error: GraphqlError) => string,
    messagePrefixKey?: string,
    intl: IntlShape,
  },
) => (
  errors.map((error) => {
    if (messagePrefixKey && intl) {
      return sanitizeGraphQLError(error, intl, messagePrefixKey)
    }

    if (messageCallback) {
      return messageCallback(error)
    }

    return extentionErrors(error) || error.message
  })
)

export const sanitizeGraphQLError = (error: GraphqlError, intl: IntlShape, messagePrefixKey: string) => {
  return intl.formatMessage({
    id: `${messagePrefixKey}${error.message}`,
    defaultMessage: intl.formatMessage({
      id: `common.errors.${error.message}`,
      defaultMessage: extentionErrors(error) || intl.formatMessage({ id: 'common.genericRequestError' }),
    }),
  })
}

const extentionErrors = (error: GraphqlError) => {
  return error.extensions?.errors.map((error: { attribute: string, messages: string[] }) => {
    return `${error.attribute}: ${error.messages.join('<br />')}`
  }).join('<br />')
}

export const showErrors = (messages: string[] | string) => {
  (Array.isArray(messages) ? messages : [messages]).forEach(showNotification)
}

const showNotification = (message: string) => {
  toast.error(message)
}

export const closeErrorNotifications = () => {
  toast.dismiss()
}

type GraphqlError = {
  message: string
  extensions?: {
    errors: { attribute: string, messages: string[] }[]
  }
}
